import styles from "./style.module.scss";

import Image from "next/legacy/image";
import { useEffect, useState } from "react";
import { PLACE_HOLDER_IMAGE_PATH } from "@lib/sharedUtils";

import { GQLOffers } from "@gql/types/gql";
import { removeWordFromString } from "@helpers/removeWordFromString";
export default function Vendor({
    vendor,

    listToAdd,
}: {
    vendor: GQLOffers;

    listToAdd: string[];
}) {
    const element = listToAdd.find(
        (el) => el === removeWordFromString(vendor.slug as string),
    );
    const [isSelect, setIsSelect] = useState(!!element);

    useEffect(() => {
        if (
            listToAdd.find(
                (el) => el === removeWordFromString(vendor.slug as string),
            )
        ) {
            setIsSelect(true);
        } else {
            setIsSelect(false);
        }
    }, [listToAdd]);

    const selectedHandler = () => {
        if (isSelect) {
            setIsSelect(false);
        } else {
            setIsSelect(true);
        }
    };

    return (
        <div
            className={`lg:w-[180px] lg:h-[108px] w-[128px] h-[86px] ${styles["vendorStyle"]}  flex justify-center cursor-pointer ${styles["selectStyle"]}`}
            onClick={selectedHandler}
            data-selected={isSelect}
        >
            {vendor?.logo?.fullPath ? (
                <Image
                    src={vendor?.logo?.fullPath}
                    alt="logo"
                    // layout="fill"
                    objectFit="contain"
                    width={110}
                    height={44}
                />
            ) : (
                <span className="relative w-[50%] h-[50%] flex self-center ">
                    <Image
                        src={PLACE_HOLDER_IMAGE_PATH}
                        alt="logo"
                        layout="fill"
                    />
                </span>
            )}
        </div>
    );
}
